import React from 'react';
import { motion } from 'framer-motion';

const ContactUs = () => {
  return (
    <div className="flex flex-col py-20 px-6 md:px-20 justify-center items-center w-full min-h-screen bg-zinc-100">
      <motion.div
        className="max-w-2xl text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1
          className="text-5xl md:text-6xl font-righteous text-golden mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Get in Touch
        </motion.h1>

        <motion.p
          className="text-2xl md:text-3xl text-gray-700 mb-6 leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Send us an email at
        </motion.p>

        <motion.a
          className="text-3xl md:text-4xl text-golden hover:text-gray-700 transition-colors duration-300 font-semibold inline-block"
          href="mailto:info@sublimedancecompany.com"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          whileHover={{ scale: 1.05 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          info@sublimedancecompany.com
        </motion.a>

        <motion.div
          className="mt-12 pt-8 border-t border-gray-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          <p className="text-lg md:text-xl text-gray-600">
            We'd love to hear from you about collaborations, performances, or any inquiries.
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ContactUs;
